// src/screens/admin/cotizadorRegistros.js
// Junta los datos del historial de precios: cada opción guardada con ciudad y
// precio de vuelo, más lo importado desde CSV. Se calcula con las mismas
// reglas del Cotizador (calcularOpcion), sin redondear.
import { listarCotizaciones, listarHistorialImportado } from '../../services/cotizadorService';
import { calcularOpcion } from '../../services/cotizadorCalc';
import { quitarRepetidos } from '../../services/cotizadorHistorial';

export async function cargarRegistros(ajustes, horarios) {
  const [cots, importados] = await Promise.all([listarCotizaciones(), listarHistorialImportado()]);
  const propios = [];
  cots.forEach((c) => {
    c.opciones.forEach((op) => {
      const ciudad = String(op.ciudad || '').replace(/\s*\+.*$/, '').trim();
      if (!ciudad) return;
      const r = calcularOpcion({ cotizacion: c, opcion: op, ajustes, horarios });
      if (r.mejorCosto === null) return;
      propios.push({
        destino: ciudad, costo: r.mejorCosto, fechaCot: String(op.created_at || c.created_at || '').slice(0, 10),
        fechaVuelo: op.dia_vuelo, aerolinea: op.aerolinea || '', fuente: r.mejorFuente || '',
        escalas: op.escalas === null || op.escalas === undefined ? null : Number(op.escalas),
        origen: 'cotizacion', opcionId: op.id,
      });
    });
  });
  return quitarRepetidos([...propios, ...importados]);
}
